import { omit } from 'lodash';
import { UserModel } from '@/helpers/entities/models/UserModel';
import { standardDateAndTime } from '@/helpers/DateFormatter';
/**
 * Maintenance Log ORM
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.13}
 */
export class MaintenanceModel {
    constructor(payload) {
        const basicParams = omit(payload, 'issuer');
        Object.assign(this, basicParams);
        this.issuer = new UserModel(payload.issuer);
    }
    get maintenanceDate() {
        return standardDateAndTime(this.createdAt);
    }
}
